var wrappers = [];

window.formatNum = (_number, decimal = 2, separator = ' ', decpoint = '.') => {
    let format_string = '#', r = parseFloat(_number), rr, b, exp10 = Math.pow(10, decimal);
    r = Math.round(r * exp10) / exp10;
    rr = Number(r).toFixed(decimal).toString().split('.');
    b = rr[0].replace(/(\d{1,3}(?=(\d{3})+(?:\.\d|\b)))/g, "\$1" + separator);
    r = (rr[1] ? b + decpoint + rr[1] : b);
    return format_string.replace('#', r);
};

$(document).ready(function () {

    // crossbrowser svg
    window.svg4everybody();

    // scrollbar for breadcrumbs

    const $breadcrumbs = $('.breadcrumbs');
    if ($breadcrumbs.length > 0) {
        const $breadcrumbsList = $breadcrumbs.find('ul');

        window.PerfectScrollbar('.breadcrumbs', {
            handlers: ['drag-thumb', 'wheel', 'touch']
        });

        $breadcrumbs[0].scrollLeft = $breadcrumbsList[0].scrollWidth - $breadcrumbs[0].clientWidth;
    }

    // slick visibility slides settings
    $('.slider-solutions')
        .on('init',
            function (slick) { sliderIndexes(slick.currentTarget); }
        )
        .on('afterChange',
            function (slick, currentSlide) { sliderIndexes(slick.currentTarget); }
        );

    $('.videos-slider')
        .on('init',
            function (slick) {
                sliderIndexes(slick.currentTarget);
            }
        )
        .on('afterChange',
            function (slick) { sliderIndexes(slick.currentTarget); }
        );

    function sliderIndexes(dom) {
        var $dom = $(dom);
        var cur_ind = $dom.find('.slick-slide.slick-current').index();
        $dom.find('.slick-slide').removeClass('zindex1').removeClass('zindex2').removeClass('zindex3').removeClass('zindex4');
        var cur_ind_zp1 = cur_ind + 1;
        var cur_ind_zp2 = cur_ind + 2;
        var cur_ind_zp3 = cur_ind + 3;
        var cur_ind_zp4 = cur_ind + 4;
        var cur_ind_zp5 = cur_ind + 5;
        var cur_ind_zp6 = cur_ind + 6;
        var cur_ind_zp7 = cur_ind + 7;
        $dom.find('.slick-slide').eq(cur_ind_zp1).addClass('zindex1');
        $dom.find('.slick-slide').eq(cur_ind_zp2).addClass('zindex2');
        $dom.find('.slick-slide').eq(cur_ind_zp3).addClass('zindex3');
        $dom.find('.slick-slide').eq(cur_ind_zp4).addClass('zindex4');
        $dom.find('.slick-slide').eq(cur_ind_zp5).addClass('zindex5');
        $dom.find('.slick-slide').eq(cur_ind_zp6).addClass('zindex6');
        $dom.find('.slick-slide').eq(cur_ind_zp7).addClass('zindex7');
    }

    const $solutionMaterialSlider = $('.solution-block__items.slider');

    $solutionMaterialSlider.on('init', (_, slick) => {
        slick.$prevArrow.hide();
    });

    $solutionMaterialSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        fade: false,
        centerPadding: '0',
        infinite: false,
        swipe: false
    }).on('afterChange', (_, slick) => {
        if (slick.currentSlide <= 0) {
            slick.$prevArrow.hide();
        }
        else {
            slick.$prevArrow.show();
        }
        if (slick.currentSlide >= slick.slideCount - 1) {
            slick.$nextArrow.hide();
        }
        else {
            slick.$nextArrow.show();
        }
    });

    $('.solution-slider').each(function () {
        wrapper = $(this)[0];
        wrappers.push(wrapper);
    });

    $('.solution-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        fade: false,
        centerPadding: '0',
        adaptiveHeight: true,
        infinite: true,
        touchThreshold: 30,
    });

    $('.videos-slider').each(function () {
        $(this).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            fade: false,
            centerPadding: '0',
            adaptiveHeight: true,
            variableWidth: true,
            infinite: true,
            touchThreshold: 25,
            appendDots: $(this).siblings('.videos-desc')
        });
    });

    $('.slider-solutions').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        fade: false,
        centerPadding: '0',
        adaptiveHeight: true,
        variableWidth: true,
        infinite: true,
        touchThreshold: 30,
        responsive: [
            {
                breakpoint: 1269,
                settings: {
                    arrows: false
                }
            }
        ]
    });

    $('.slider-objects').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        fade: false,
        centerPadding: '0',
        adaptiveHeight: true,
        infinite: true,
        touchThreshold: 30,
        responsive: [
            {
                breakpoint: 1269,
                settings: {
                    variableWidth: true,
                    arrows: false
                }
            }
        ]
    });

    $('.history-dates-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: false,
        centerPadding: '0',
        adaptiveHeight: false,
        variableWidth: true,
        infinite: false,
        focusOnSelect: true,
        asNavFor: '.history-slider',
        touchThreshold: 30
    });

    let historySlider = $('.history-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        centerPadding: '0',
        adaptiveHeight: true,
        infinite: false,
        asNavFor: '.history-dates-slider',
        touchThreshold: 30
    });

    $('.history-link-prev').on('click', () => {
        historySlider.slick('slickPrev')
    });

    $('.history-link-next').on('click', () => {
        historySlider.slick('slickNext')
    });

    const $historyDates = $('.history-dates-slider2');
    $historyDates.on('init', (event, slick) => {
        slick.$prevArrow.hide();
    });
    $historyDates.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        fade: false,
        centerPadding: '0',
        adaptiveHeight: true,
        variableWidth: true,
        infinite: false,
        focusOnSelect: true,
        touchThreshold: 30
    });
    $historyDates.on('afterChange', (event, slick) => {
        if (slick.currentSlide === 0) {
            slick.$prevArrow.hide();
        }
        else {
            slick.$prevArrow.show();
        }
        if (slick.currentSlide === 12) {
            slick.$nextArrow.hide();
        }
        else {
            slick.$nextArrow.show();
        }
    });

    $('.popup-video').magnificPopup({
        type: 'iframe',
        preloader: false,
        mainClass: 'mfp-with-zoom',
        fixedContentPos: false,
        zoom: {
            enabled: true,
            duration: 300
        }
    });

    $('.scroll-theme').each((_, el) => new window.PerfectScrollbar(el));

    $('.question-item__head').click(function () {
        const $qi = $(this).parent().parent();
        if ($qi.hasClass('active')) {
            $qi.find('.question-item__main').slideToggle('slow', function () {
                $qi.removeClass('active');
            });
        }
        else {
            $qi.siblings('.active').find('.question-item__main').slideToggle('slow', function () {
                $(this).parent().parent().removeClass('active');
            });
            $qi.find('.question-item__main').slideToggle('slow', function () {
                $qi.addClass('active');
            });
        }
    });

    // modal
    $('.link-modal').click(function (e) {
        var className = $(e.currentTarget).hasClass('link-spec') ? 'modal-spec' : 'modal-active';
        var id = $(this).attr('href');
        $.magnificPopup.open({
            items: {
                src: id
            },
            type: 'inline',
            preloader: false,
            mainClass: 'mfp-with-zoom',
            showCloseBtn: false,
            callbacks: {
                open: function () {
                    $('body').addClass(className);
                },
                close: function () {
                    $('body').removeClass(className);
                }
            },
            zoom: {
                enabled: true,
                duration: 300
            }
        });
    });


    $(document).on('click', '.modal-close', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    // styled select
    $('select').each(function (_index, _dom) {
        const $dom = $(_dom);
        if (!$dom.hasClass('non-selectize')) {
            $dom.selectize({
                allowEmptyOption: true,
                onFocus: function (e) {
                    this.$input.closest('.select').addClass('is-open');
                },
                onBlur: function (e) {
                    const $select = this.$input.closest('.select').removeClass('is-open');
                    const isEmpty = $(_dom)[0].selectize.items.length === 0;
                    if (isEmpty) {
                        $select.removeClass('complete');
                    }
                    else {
                        $select.addClass('complete');
                    }
                },
                onChange: function (e) {
                    if ($(_dom).val() > 0) {
                        this.$input.closest('.select').addClass('complete');
                    }
                    else {
                        this.$input.closest('.select').removeClass('complete');
                    }
                }
            });
        }
    });

    $('.selectize-input').click(function (e) {
        var $target = $(e.currentTarget);
        if ($target.data('has-scrollbar') === void 0) {
            new window.PerfectScrollbar($target.closest('.select').find('.selectize-dropdown-content')[0]);
        }

    });

    // win btn
    var items = $('.btn-win');
    for (var i = 0; i < items.length; i++) {
        $(items[i]).click(function () {
            var id = $(this).attr('href');
            $(this).toggleClass("active");
            $(id).toggleClass("active");
            $("body").toggleClass("win-active");
            return false;
        });
    }
    $(document).click(function (event) {
        if ($(event.target).closest(".win").length) return;
        $('.win.active').removeClass("active");
        $('.btn-win.active').removeClass("active");
        $('body').removeClass("win-active");
        event.stopPropagation();
    });
    $(".win-close").click(function (event) {
        $('.win.active').removeClass("active");
        $('.btn-win.active').removeClass("active");
        $('body').removeClass("win-active");
    });


    // field placeholder
    $(".field input, .field textarea, .field__title").on("click", function () {
        $(this).closest(".field").addClass("active");
        $(this).closest(".field").find("input").focus();
        $(this).closest(".field").find("textarea").focus();
    });

    $(".field input, .field textarea").focusout(function () {
        if ($(this).val() === "")
            $(this).closest(".field").removeClass("complete active");
        else {
            $(this).closest(".field").addClass("complete");
        }
    });

    // fixed header
    let $header = $(".header");
    let $window = $(window);
    let headScrollTop = $window.scrollTop();
    let $linksWrapper = $('.links-categ-wrapper');

    function setHeader() {
        let currentScrollTop = $window.scrollTop();
        if (currentScrollTop > 30 && $header.hasClass("default")) {
            $header.fadeIn(0, function () {
                $header.removeClass("default").addClass("fixed");
            });
        } else if (currentScrollTop <= 30 && $header.hasClass("fixed")) {
            $header.fadeIn(0, function () {
                $header.removeClass("fixed").addClass("default");
            });
        }
        if (currentScrollTop > headScrollTop) {
            $header.removeClass('scroll-top');
            $linksWrapper.removeClass('scroll-top');
        } else {
            // upscroll code
            $header.addClass('scroll-top');
            $linksWrapper.addClass('scroll-top');
        }
        headScrollTop = currentScrollTop;
    }

    $(window).scroll(function () {
        setHeader();
    });

    setHeader();

    $(".links-categ-wrapper").stick_in_parent({
        spacer: false,
        bottoming: false
    });

    (function ($) {
        var handler = function ($dom) {
            var $items = $('.tab');
            $dom.addClass('current').siblings().removeClass('current');
            if ($dom.data('group') === '') {
                $items.addClass('current');
            }
            else {
                $items.removeClass('current').filter('[data-filter-group=' + $dom.data('group') + ']').addClass('current');
            }
        };
        $(document).on('click', '.js-tab-link', function (e) {
            var $target = $(e.target);
            handler($target);
        });
        handler($('.js-tab-link.current'));
    })(jQuery)

});